import { useState } from 'react';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md shadow-sm z-50 border-b border-[#6B7C59]/10">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/79237683e9ba10f5e0240023cd0edfec/1a24fa3838f0b3226a529a6e3a5c0c58.png"
              alt="Nova Conciergerie Logo"
              className="h-10 w-auto mr-3 object-contain"
            />
            <h1 
              className="text-2xl font-normal text-[#2C3E2D] tracking-tight"
              style={{ fontFamily: '"Cormorant Garamond", serif' }}
            >
              Nova <span className="italic">Conciergerie</span>
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a 
              href="#about" 
              className="text-[#2C3E2D] hover:text-[#6B7C59] transition-colors duration-200 font-light tracking-wide"
              style={{ fontFamily: '"Montserrat", sans-serif' }}
            >
              À propos
            </a>
            <a 
              href="#services" 
              className="text-[#2C3E2D] hover:text-[#6B7C59] transition-colors duration-200 font-light tracking-wide"
              style={{ fontFamily: '"Montserrat", sans-serif' }}
            >
              Services
            </a>
            <a 
              href="#contact" 
              className="text-[#2C3E2D] hover:text-[#6B7C59] transition-colors duration-200 font-light tracking-wide"
              style={{ fontFamily: '"Montserrat", sans-serif' }}
            >
              Contact
            </a>
            <a 
              href="#contact" 
              className="px-6 py-3 bg-[#6B7C59] text-white rounded-lg hover:bg-[#5A6B49] transition-all duration-200 font-normal text-sm whitespace-nowrap cursor-pointer tracking-wide"
              style={{ fontFamily: '"Montserrat", sans-serif' }}
            >
              Devis gratuit
            </a>
          </nav>

          {/* Mobile menu button */}
          <button 
            onClick={toggleMobileMenu}
            className="md:hidden w-10 h-10 flex items-center justify-center text-[#2C3E2D] hover:text-[#6B7C59] transition-colors cursor-pointer"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-[#6B7C59]/10">
            <nav className="flex flex-col space-y-4">
              <a 
                href="#about" 
                onClick={closeMobileMenu}
                className="text-[#2C3E2D] hover:text-[#6B7C59] transition-colors duration-200 font-light tracking-wide"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                À propos
              </a>
              <a 
                href="#services" 
                onClick={closeMobileMenu}
                className="text-[#2C3E2D] hover:text-[#6B7C59] transition-colors duration-200 font-light tracking-wide"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                Services
              </a>
              <a 
                href="#contact" 
                onClick={closeMobileMenu}
                className="text-[#2C3E2D] hover:text-[#6B7C59] transition-colors duration-200 font-light tracking-wide"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                Contact
              </a>
              <a 
                href="#contact" 
                onClick={closeMobileMenu}
                className="px-6 py-3 bg-[#6B7C59] text-white rounded-lg hover:bg-[#5A6B49] transition-all duration-200 font-normal text-sm whitespace-nowrap cursor-pointer tracking-wide inline-block text-center"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                Devis gratuit
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
